import { FeatureModule } from '@/features/earn';
import { useNavigatorPage } from '@/features/exchange-sub-account/hooks/useNavigatorPage.hook';
import React, { useEffect } from 'react';
import { RootStackRoutes } from 'types';

export interface LayoutContextProps {
  children?: React.ReactElement;
  apps: FeatureModule[];
  routeName: string;
}

export const getObjectScreenNameFromPath = (apps: FeatureModule[], pathName: string) => {
  const routes = apps.filter((a) => a.routes);
  var screenName;
  var routeStackName: string = RootStackRoutes.Root;
  for (const item in routes) {
    for (const child in routes[item].routes) {
      const childRoute: any = routes[item].routes[child];
      if (pathName === childRoute?.path) {
        screenName = child;
        routeStackName = routes[item].name;
        break;
      }
    }
  }
  return { screenName, routeStackName };
};

export let popStateLockedMap = new Map();

export const UtxAppNavigatorEmbed = (props: LayoutContextProps) => {
  const navigator = useNavigatorPage();
  const { apps, routeName } = props;
  const routes = apps.filter((a) => a.routes);

  useEffect(() => {
    var route = routeName;
    if (routeName.indexOf('?') > -1) {
      route = routeName.split('?')[0];
    }
    const pathName = `/${route}`;
    var screenNameObject = getObjectScreenNameFromPath(apps, pathName);
    if (screenNameObject.screenName) {
      navigator.replaceScreen(screenNameObject.routeStackName, screenNameObject.screenName);
    } else {
      for (const item in routes) {
        if (routes[item].name === route) {
          navigator.replaceScreen(routes[item].name, undefined);
          break;
        }
      }
    }
  }, []);

  return <>{props.children}</>;
};
